export const OTP_TYPES = {
  SMS: {
    value: 'SMS',
    name: 'SMS'
  },
  WHATSAPP: {
    value: 'WHATSAPP',
    name: 'Whatsapp'
  }
};

export const MK_JEWELLERS_COMPANY_ID = '-LaAArTYr1ZzOsgbS70t';
export const DAD_OF_CAD_COMPANY_ID = '-NMmigirsHiCKDp2w4PW';

// Companies whose visitors never see a CAPTCHA. sms-service skips device token
// verification for the same ids, so these stand-in tokens are never checked.
//
// Each company needs its own token: sms-service looks the nonce up by deviceToken
// and takes the newest match, so two companies sharing one string would let their
// visitors pick up each other's nonce.
export const SKIP_CAPTCHA_DEVICE_TOKENS = {
  [MK_JEWELLERS_COMPANY_ID]: 'mk_jewellers',
  [DAD_OF_CAD_COMPANY_ID]: 'dad_of_cad'
};
